// extracted by mini-css-extract-plugin
export default {"paginationItems":"Pagination_paginationItems__23Stv"};